import { axiosInstance } from 'src/util/axios/instance.axios'
import { ProjectRequirements, MappedSkillsResponse, ProjectSkill, CreateProjectResponse, CreateProjectDto, AnalyzeProjectRequirementsDto, ProjectListItemDto, ProjectDetailsDto, UpdateProjectDatesDto, RecommendedUsersDto } from '../model/project-builder'

export async function analyzeProjectRequirements(dto: AnalyzeProjectRequirementsDto): Promise<ProjectRequirements> {
  const { data } = await axiosInstance.request<ProjectRequirements>({
    method: 'POST',
    url: '/project-builder/analyze-project',
    data: dto,
  })

  return data
}

export async function mapSkillsToOrganisation(suggestedSkills: ProjectSkill[]): Promise<MappedSkillsResponse> {
  const { data } = await axiosInstance.request<MappedSkillsResponse>({
    method: 'POST',
    url: '/project-builder/map-skills',
    data: { suggestedSkills },
  })

  return data
}

export async function createProject(dto: CreateProjectDto): Promise<CreateProjectResponse> {
  const { data } = await axiosInstance.request<CreateProjectResponse>({
    method: 'POST',
    url: '/project-builder/create-project',
    data: dto,
  })

  return data
}

export async function getProjects(): Promise<ProjectListItemDto[]> {
  const { data } = await axiosInstance.request<ProjectListItemDto[]>({
    method: 'GET',
    url: '/project-builder/projects-overview',
  })

  return data
}

export async function getProjectDetails(projectId: string): Promise<ProjectDetailsDto> {
  const { data } = await axiosInstance.request<ProjectDetailsDto>({
    method: 'GET',
    url: `/project-builder/project/${projectId}`,
  })

  return data
}

export async function getRecommendedUsers(projectId: string): Promise<RecommendedUsersDto> {
  const { data } = await axiosInstance.request<RecommendedUsersDto>({
    method: 'GET',
    url: `/project-builder/project/${projectId}/recommended-users`,
  })

  return data
}

export async function updateProjectDates(
  projectId: string,
  dto: UpdateProjectDatesDto,
): Promise<ProjectDetailsDto> {
  const { data } = await axiosInstance.request<ProjectDetailsDto>({
    method: 'PATCH',
    url: `/project-builder/project/${projectId}/dates`,
    data: dto,
  })

  return data
}

export async function removeProjectUser(
  projectId: string,
  userId: string,
): Promise<ProjectDetailsDto> {
  const { data } = await axiosInstance.request<ProjectDetailsDto>({
    method: 'DELETE',
    url: `/project-builder/project/${projectId}/user/${userId}`,
  })

  return data
}

export async function addUsersToProject(
  projectId: string,
  userIds: string[],
  notifyUsers: boolean,
): Promise<ProjectDetailsDto> {
  const { data } = await axiosInstance.request<ProjectDetailsDto>({
    method: 'POST',
    url: `/project-builder/project/${projectId}/users`,
    data: { userIds, notifyUsers },
  })

  return data
}

export async function respondToProjectInvitation(
  projectId: string,
  accepted: boolean,
): Promise<ProjectDetailsDto> {
  const { data } = await axiosInstance.request<ProjectDetailsDto>({
    method: 'POST',
    url: `/project-builder/project/${projectId}/respond`,
    data: { accepted },
  })

  return data
}

export async function deleteProject(
  projectId: string,
): Promise<void> {
  await axiosInstance.request({
    method: 'DELETE',
    url: `/project-builder/${projectId}`,
  })
}